<template>
	<div id="upload-image-wrapper" v-loading="uploading" class="upload-image-wrapper img_userInfo_big" :class="uploadType == 1 ? '' : ''">
		<!-- multiple 设置多张选择为true 则为false  -->
		<el-upload
			key="rowId_ref"
			ref="elUpload"
			class="elUpload"
			:auto-upload="false"
			action=""
			:before-upload="beforeUpload"
			:class="[fileList.length == maxLimit || fileList.length > maxLimit ?  'hidden-Btn' : '']"
			:file-list="fileList"
			:limit="maxLimit"
			:multiple="true"
			:on-change="handleChange"
			:on-exceed="handleExceed"
			:on-preview="handlePreview"
			:on-remove="handleRemove"
			:on-success="handleSuccess"
			:accept="thatAcceptType"
			list-type="picture-card">
			<!-- hidden-Btn -->
			<div class="paste-tip">
			  <i class="el-icon-plus upload-icon"></i>
			</div>
		</el-upload>
		
		<!-- 点击查看放大 -->
		<!-- <el-dialog :visible.sync="dialogVisible" width="100%" top="0" :modal="false" @click.stop>
			<img :src="dialogUrl" alt="" class="dialog_img">
			<div class="dialog-controls">
				<button type="button" @click.stop="prevImage" :disabled="currentImageIndex === 0"><i class="el-icon-arrow-left"></i></button>
				<button type="button" @click.stop="nextImage" :disabled="currentImageIndex === fileList.length - 1"><i class="el-icon-arrow-right"></i></button>
			</div>
		</el-dialog> -->
		
		<div class="LoadingBox" v-if="Loading">
			<Loading :LoadingText="LoadingText"></Loading>
		</div>
		
		<handlePreviewSwiper v-if="handlePreviewShow" :fileList="PreviewSwiper" :currentUrl="currentUrl" :itemtype="swiperSlide" @closurePreview="handlePreviewShow = false"></handlePreviewSwiper>

	</div>
</template>

<script>
import { post_community_upload } from '@/api/community.js'
	var that
	export default {
		name: "ImgUploadUserInfo",
		
		props: {
			uploadType: {
				type: Number,
				default: 1,  // 必填 1头像, 2背景
			},
			maxFileList: {
				type: Number,
				default: 9,  // 最多
			},
			acceptType: {
				type: String,
				default: "image/jpeg, image/png, image/webp",
			},
			FileList: {
				type: Array,
				default() {
					return []
				}
			},
		},
		
		data() {
			return {
				uploadUrl: "1", // 上传截图相关数据
				screenshotUrl_arr: [],
				dialogUrl: "",
				dialogVisible: false,
				// 粘贴上传数据
				fileList: this.FileList,
				uploading: false,
				maxLimit: this.maxFileList,
				thatAcceptType: this.acceptType,
				Loading: false,
				LoadingText: false,
				triggerPicsUploadCopy: this.triggerPicsUpload,
				currentImageIndex: 0, // 当前显示的图片索引
				PreviewSwiper:[],
				currentUrl: "",
				handlePreviewShow: false,
				swiperSlide: "",
			}
		},
		
		watch: {
			"acceptType": {
				handler: function (val, oldval) {
					this.thatAcceptType = this.acceptType
				}
			},
			"$route": {
				handler: function (newValue, oldValue) {
					this.dialogVisible = false
				},
				deep: true
			},
			// "fileList": {
			// 	handler: function (val, oldval) {
			// 		console.log(this.fileList)
			// 		if (this.fileList.length == 0) {
			// 			this.uploadDisabled = 0
			// 		} else {
			// 			this.uploadDisabled = this.fileList.length
			// 		}
			// 	},
			// 	deep: true,
			// },
			"FileList": {
				handler: function (val, oldval) {
					console.log(this.FileList)
					this.fileList = this.FileList
				}
			},
		},
		
		beforeCreate() {
			// const vm = this
		},

		created() {

		},

		beforeDestroy() {

		},
		
		mounted() {
			that = this
			// 将触发方法绑定到父组件的函数上
			if (this.triggerPicsUploadCopy) {
				this.triggerPicsUploadCopy = this.triggerPicsUploadCopy.bind(this); // 绑定 this
				this.$refs.elUpload.$on('click', this.triggerPicsUploadCopy); // 使用 copy 属性
			}
			
			this.$nextTick(() => {
				this.set_upload_input_files()
			})
			// 点击上传区域后延迟重新赋值
			this.$el.addEventListener('click', () => {
				setTimeout(() => this.set_upload_input_files(), 30)
			})
		},
		
		methods: {
			set_upload_input_files(){
				// 精准选中当前组件内上传文件input
				const fileInput = this.$el.querySelector('.img_userInfo_big .el-upload__input')
				if (fileInput) {
					fileInput.setAttribute('aria-label', 'Upload user profile picture')
				}
			},
			OpenPreviewSwiper(fileList, item, swiperSlide){
				// let currentRouteName = this.$route.name;
				// if(currentRouteName != 'PostDetails'){ return }
				this.PreviewSwiper = fileList
				this.currentUrl = item
				this.handlePreviewShow = true
				this.swiperSlide = swiperSlide
			},
			
			triggerPicsUpload() {
			   // 手动触发 el-upload 的点击事件，打开文件选择框
			   this.$refs.elUpload.$el.querySelector('input[type="file"]').click(); // 手动触发 input 的点击事件
			},

			// 过滤不符合条件图片
			FormatSize(file, fileList) {
				const index = fileList.findIndex((ele) => {
					return ele.url === file.url
				})
				// 当查找失败返回
				if (index === -1) {
					return console.log("删除失败")
				}
				// 如果找到该元素，使用splice方法删除元素
				return index
			},
			
			get_type(file, type, size, funName, fileList, width, height){
				let isType = ""
				let isMax = ""
				let formatText = ""
				let sizeText = ""
				if(this.uploadType == 1){
					isType = type === "image/jpeg" || type === "image/png" || type === "image/jpg" || type === "image/git" || type === "image/bmp" || type === "image/webp"
					isMax = size / 1024 / 1024 < 20 //图片20M
					
					formatText = `${this.$t('FileUploadArr.avatar_image_formats')} JPG, JPEG, PNG!`
					sizeText = `${this.$t('FileUploadArr.avatar_image_size')} 20MB!`
				}else if(this.uploadType == 2){
					isType = type === "image/jpeg" || type === "image/png" || type === "image/jpg" || type === "image/git" || type === "image/bmp" || type === "image/webp"
					isMax = size / 1024 / 1024 < 20 //图片20M
					// isType = type === "video/mp4"
					// isMax = size / 1024 / 1024 < 60 //视频60M
					
					formatText = `${this.$t('FileUploadArr.background_image_formats')} JPG, JPEG, PNG!`
					sizeText = `${this.$t('FileUploadArr.background_image_size')} 20MB!`
				}
				
				if (!isType) {
					if(funName == "handleChange"){
						let index = this.FormatSize(file, fileList)
						fileList.splice(index, 1)
					}
					this.$message(formatText, "error")
					return false
				}
				if (!isMax) {
					if(funName == "handleChange"){
						let index = this.FormatSize(file, fileList)
						fileList.splice(index, 1)
					}
					this.$message(sizeText, "error")
					return false
				}
				if(funName == "handleChange" && (isType || isMax)){
					this.post_community_upload(file.raw, width, height)
				}
				
			},

			// 上传处理
			async handleChange(file, fileList) {
				// 获取图片宽高
			   const getImageDimensions = async (file) => {
			      return new Promise((resolve, reject) => {
			         const reader = new FileReader();
			         reader.onload = function (e) {
			            const img = new Image();
			            img.onload = function () {
			               const width = img.width;
			               const height = img.height;
			               console.log('图片宽度:', width, '图片高度:', height);
			               resolve({ width, height });
			            };
			            img.src = e.target.result;
			         };
			         reader.onerror = (error) => {
			            reject(error);
			         };
			         reader.readAsDataURL(file.raw);
			      });
			   };
			
			   try {
			      const dimensions = await getImageDimensions(file);
			      const { width, height } = dimensions;
			      this.get_type(file, file.raw.type, file.size, 'handleChange', fileList, width, height);
			   } catch (error) {
			      console.error('获取图片宽高出错:', error);
			   }
			},

			// 超量提醒
			handleExceed() {
				if(this.uploadType == 1){
					this.$message(`${this.$t('FileUploadArr.avatar_max_text')}  ${this.maxLimit} ${this.$t('FileUploadArr.avatar_files')}`, "warn")
				}else if(this.uploadType == 2){
					this.$message(`${this.$t('FileUploadArr.background_max_text')}  ${this.maxLimit} ${this.$t('FileUploadArr.background_files')}`, "warn")
				}
				// this.$message(`You can only upload up to  ${this.maxLimit} image files`, "warn")
			},

			// 上传成功   暂时无作用
			handleSuccess(res, file) {

			},

			// 删除已经上传好的照片中的照片 this.fileList
			handleRemove_file(file) {
				let index = this.fileList.findIndex((ele) => {
					return ele.uid === file.uid
				})
				//当查找失败返回
				if (index === -1) {
					return console.log("删除失败")
				}
				//如果找到该元素，使用splice方法删除元素
				this.fileList.splice(index, 1)
			},

			// 删除图片
			handleRemove(file, fileList) {
				this.handleRemove_file(file)
				// 传下去的fileList会被复制，当删除时，此组件的fileList不会被同步修改，需要手动清空
				var arr = []
				fileList.forEach((item) => {
					//截取是为去掉添加的http://
					let url = item.url.slice(7, item.url.length)
					arr.push(url)
				})
			  if(file){
				 var url = file.url ? file.url : ''
				 if(this.uploadType == 1){
					this.$emit("remove_imgs_Avatar", url)
				 }else if(this.uploadType == 2){
					this.$emit("remove_imgs_Background", url)
				 }
			  }
			},

			//上传时验证图片格式
			beforeUpload(file) {
				// return this.get_type(file, file.type, file.size, 'beforeUpload')
			},
			
			//上传文件
			post_community_upload(fileRaw, width, height){
			   this.Loading = true
				const fd = new window.FormData()
				fd.append("file[]", fileRaw)//文件
				post_community_upload(fd)
			   .then((res) => {
					console.log(res)
					if(res.code == 0){
						console.log('上传成功')
						let obj = res.data.list[0]
						obj.width = width ? width : 0
						obj.height = height ? height : 0
						 if(this.uploadType == 1){
							this.$emit("save_imgs_Avatar", obj)
						 }else if(this.uploadType == 2){
							this.$emit("save_imgs_Background", obj)
						 }
					}else{
						this.exception_handling(res, "upload", fileRaw)
					}
						this.Loading = false
				})
				.catch((err) => {
					console.log(err)
					this.exception_handling(err, "upload", fileRaw)
				})
			},
			
			//异常处理
			exception_handling(err, type, fileRaw){
				this.Loading = false
				// this.handleRemove_file(fileRaw)
				this.fileList = []
				this.$errorMessage(err)
				// this.$message('err.data.message', 'error')
			},

			// 点击查看大图
			handlePreview(file) {
				// 整理数据结构兼容帖子列表的结构
				let pics = []
				console.log(file)
				console.log(this.fileList)
				this.fileList.forEach((item) => {
					let obj = {
						width: item.width,
						height: item.height,
						url: item.url,
						video: "",
						ios_url: "",
					}
					pics.push(obj)
				})
				let fileList = {
				   videos: [], //视频
				   video_cover: "", //视频封面
					post_type: 1, //类型
				   SlideTotal: this.fileList.length,
				   pics: pics
				}
				console.log(fileList)
				this.OpenPreviewSwiper(fileList, file.url, 'UploadImg')
				// this.currentImageIndex = this.fileList.findIndex(f => f.uid === file.uid);
				// this.dialogUrl = file.url || file.response.url;
				// this.dialogVisible = true;
			},
			
			nextImage() {
				if (this.currentImageIndex < this.fileList.length - 1) {
					this.currentImageIndex++;
					this.dialogUrl = this.fileList[this.currentImageIndex].url || this.fileList[this.currentImageIndex].response.url;
				}
			},
			
			prevImage() {
				if (this.currentImageIndex > 0) {
					this.currentImageIndex--;
					this.dialogUrl = this.fileList[this.currentImageIndex].url || this.fileList[this.currentImageIndex].response.url;
				}
			}
		},
	}
</script>

<style lang="less" scoped>
	.upload-image-wrapper {
		display: block;
		vertical-align: top;
		::v-deep .el-upload--picture-card {
			height: 100%;
			width: 100%;
			line-height: 100%;
			/* height: 80px; */
			/* width: 80px; */
			/* line-height: 80px; */
			background-size: 100% 100%;
			background-color: transparent;
			border: 1px solid #c0ccda;
			/* border: 1px dashed #c0ccda; */
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item {
			height: 100%;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		::v-deep .el-upload-list--picture-card .el-upload-list__item-thumbnail {
		   width: 100%;
		   height: 100%;
		   object-fit: cover;
		}

		::v-deep .el-upload-list--picture-card .el-upload-list__item-actions {
			/* height: 80px; */
		}
		::v-deep .el-icon-plus.upload-icon {
			color: #606266;
		}

		::v-deep .paste-tip {
			width: 100%;
			height: 100%;
			display: flex;
			z-index: 99;
			font-weight: 600;
			font-size: 16px;
			color: #99a9bf;
			color: #606266;
			display: flex;
			justify-content: center;
			align-items: center;

			.el_icon {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
		
		::v-deep .hidden-Btn .el-upload--picture-card{
			display: none !important;
		}
  }

  .hidden-Btn {
    ::v-deep .el-upload {
      display: none;
    }
  }
  
  ::v-deep  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 35px;
  }
	::v-deep .v-modal{
		opacity: 0 !important;
		z-index: 0;
	}
  .upload-image-wrapper {
		::v-deep .el-dialog__header{
			padding: 0px;
		}
  }
  ::v-deep .el-dialog {
		height: 100vh;
		margin: 0px;
		background-color: rgba(0, 0, 0, 0.8);
  }
  ::v-deep .el-dialog__body {
    width: 100%;
  	 height: 100%;
    max-height: calc(100vh - 30px);
    box-sizing: border-box;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  ::v-deep .el-dialog__body {
	  img{
		  max-height: 80vh;
	  }
  }
  .avatarBox > .upload-image-wrapper > ::v-deep .el-upload--picture-card{
  		border-radius: 58px !important;
  }
 
  .avatarBox .upload-image-wrapper{
	  width: 100%;
	  height: 100%;
	  overflow: hidden;
  }
  .avatarBox>div:first-child{
	  height: 100%;
  }
  .avatarBox .elUpload,
  .avatarBox .el-upload-list--picture-card .el-upload-list__item-actions,
  .avatarBox.upload-image-wrapper .el-upload--picture-card,
  .avatarBox.upload-image-wrapper .el-upload-list--picture-card .el-upload-list__item {
		height: 58px !important;
		width: 58px !important;
		border-radius: 58px !important;
  }
  .avatarBox .el-upload-list--picture-card .el-upload-list__item-actions{
	  font-size: 16px !important;
  }
  .avatarBox .paste-tip {
		width: 100%;
		height: 100%;
		border-radius: 58px!important;
  
		.el_icon {
			font-size: 15px;
			width: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
		}
  }
  
  .bg_img_box .upload-image-wrapper{
  	  overflow: hidden;
  }
  .bg_img_box>div:first-child{
	  height: 100%;
  }
  .bg_img_box .upload-image-wrapper,
  .bg_img_box .hidden-Btn,
  .bg_img_box .elUpload,
  .bg_img_box .el-upload-list--picture-card .el-upload-list__item-actions,
  .bg_img_box .upload-image-wrapper .el-upload--picture-card,
  .bg_img_box .upload-image-wrapper .el-upload-list--picture-card .el-upload-list__item {
		height: 100% !important;
		width: 100% !important;
  }
  
  .dialog_img{
    max-width: 100%;
    height: auto;
  }
  
  .LoadingBox{
	  position: fixed;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  z-index: 999;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  background-color: rgba(0,0 0, 0.5);
  }
  
  .dialog-controls {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 10px;
    box-sizing: border-box;
  }
  
  .dialog-controls button {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
	 width: 40px;
	 height: 40px;
	 border-radius: 40px;
	 display: flex;
	 justify-content: center;
	 align-items: center;
    cursor: pointer;
	 font-size: 25px;
  }
  .dialog-controls button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
	@media only screen and (min-width: 1023px) {
		::v-deep .el-dialog__body{
			padding: 10px 20px;
		}
		::v-deep .el-dialog__headerbtn{
			top: 15px;
			right: 15px;
		}
		::v-deep .el-dialog__headerbtn .el-dialog__close {
		   font-size: 32px;
		}
		// upload-image-wrapper
		::v-deep .el-dialog {
			height: calc(100vh - 0px);
			margin-top: 0px !important;
		}
	}
	@media only screen and (max-width: 1023px) {
		::v-deep .el-dialog__body{
			padding: 10px 10px;
		}
		::v-deep .el-dialog__headerbtn{
			top: 10px;
			right: 10px;
		}
		::v-deep .el-dialog__headerbtn .el-dialog__close {
		   font-size: 28px;
		}
		// upload-image-wrapper
		::v-deep .el-dialog {
			height: calc(100vh - 0px);
			margin-top: 0px !important;
		}
	}
</style>
